import { observable, action, computed, runInAction, decorate, reaction } from 'mobx';
import agent from '../api/agent';
import { IRequestReviewDocumentNote } from '../models/RequestReviewDocumentNote';
import { toast } from 'react-toastify';
import { RootStore } from './RootStore';

const LIMIT = 10;

export default class RequestReviewDocumentNoteStore {
    rootStore: RootStore;
    constructor(rootStore: RootStore) {
        this.rootStore = rootStore
        reaction(
            () => this.predicate.keys(),
            () => {
                this.reviewDocumentNotePages = 0;
                this.RequestReviewDocumentNoteRegistry.clear();
                this.loadRequestReviewDocumentNotes();
            }
        )
    }

    RequestReviewDocumentNoteRegistry = new Map();
    RequestReviewDocumentNote: IRequestReviewDocumentNote | null = null;
    loadingInitialReviewDocumentNotes = false;
    submitting = false;
    target = "";

    requestReviewDocumentNoteCount = 0;
    reviewDocumentNotePages = 0;

    predicate = new Map();

    setPredicate = (predicate: string, value: string | Date) => {
        this.predicate.clear();
        if (predicate !== 'My Notes') {
            this.predicate.set(predicate, value);
        } else {
            this.predicate.set('createdById', this.rootStore.userStore.user?.id)
        }
    }

    get axiosParams() {
        const params = new URLSearchParams();
        params.append('limit', String(LIMIT));
        params.append('offset', `${this.reviewDocumentNotePages ? this.reviewDocumentNotePages * LIMIT : 0}`);
        this.predicate.forEach((value, key) => {
            if (key === 'dateCreated') {
                params.append(key, value.toDateString());
            } else {
                params.append(key, value);
            }
        })
        return params;
    }


    get totalReviewDocumentNotePages() {
        return Math.ceil(this.requestReviewDocumentNoteCount / LIMIT);
    }

    setPageReviewDocumentNotes = (reviewNotePages: number) => {
        this.reviewDocumentNotePages = reviewNotePages;
    }

    get requestReviewDocumentNotesById() {
        return this.groupRequestReviewDocumentNotesById(Array.from(this.RequestReviewDocumentNoteRegistry.values()));
    };

    groupRequestReviewDocumentNotesById(requestReviewDocumentNotes: IRequestReviewDocumentNote[]) {
        const sortedRequests = requestReviewDocumentNotes.sort(
            (a, b) => parseInt(b.id) - parseInt(a.id)
        )

        return Object.entries(sortedRequests.reduce((requestReviewDocumentNotes, requestReviewDocumentNote) => {
            const id = requestReviewDocumentNote.id;
            requestReviewDocumentNotes[id] = requestReviewDocumentNotes[id] ? [...requestReviewDocumentNotes[id], requestReviewDocumentNote] : [requestReviewDocumentNote];
            return requestReviewDocumentNotes;
        }, {} as { [key: string]: IRequestReviewDocumentNote[] }));
    }

    get requestReviewDocumentNotesByDate() {
        return Array.from(this.RequestReviewDocumentNoteRegistry.values()).sort(
            (a, b) => b.dateCreated - a.dateCreated
        );
    };

    loadRequestReviewDocumentNotes = async () => {
        this.loadingInitialReviewDocumentNotes = true;
        try {
            const requestReviewDocumentNotesEnvelope = await agent.RequestReviewDocumentNotes.list(this.axiosParams);
            const { requestReviewDocumentNotesDto, requestReviewDocumentNoteCount } = requestReviewDocumentNotesEnvelope;

            runInAction('loadRequestReviewDocumentNotes', () => {
                requestReviewDocumentNotesDto.forEach((requestReviewDocumentNoteDto) => {
                    // appeal.submittedOn=new Date(appeal.submittedOn);
                    this.RequestReviewDocumentNoteRegistry.set(requestReviewDocumentNoteDto.id, requestReviewDocumentNoteDto);
                });
                this.requestReviewDocumentNoteCount = requestReviewDocumentNoteCount;
            });

        } catch (error) {
            throw error;
        }
        runInAction('loadRequestReviewDocumentNotes', () => {
            this.loadingInitialReviewDocumentNotes = false;
        });
    };

    loadRequestReviewDocumentNote = async (id: string) => {
        let RequestReviewDocumentNote = this.getRequestReviewDocumentNote(id);
        if (RequestReviewDocumentNote) {
            this.RequestReviewDocumentNote = RequestReviewDocumentNote;
            return RequestReviewDocumentNote;
        }
        else {
            this.loadingInitialReviewDocumentNotes = true;
            try {
                RequestReviewDocumentNote = await agent.RequestReviewDocumentNotes.details(id);
                runInAction('getting activity', () => {
                    this.RequestReviewDocumentNote = RequestReviewDocumentNote;
                    this.RequestReviewDocumentNoteRegistry.set(RequestReviewDocumentNote.id, RequestReviewDocumentNote);
                    this.loadingInitialReviewDocumentNotes = false;
                })
                return RequestReviewDocumentNote;
            } catch (error) {
                toast.error('problem submitting data');
            }
        }
        runInAction('loadRequestReviewDocumentNotes', () => {
            this.loadingInitialReviewDocumentNotes = false;
        });
    };

    getRequestReviewDocumentNote = (id: string) => {
        return this.RequestReviewDocumentNoteRegistry.get(id);
    }

    ClearRequestReviewDocumentNote = () => {
        this.RequestReviewDocumentNote = null;
    }

    createRequestReviewDocumentNote = async (requestReviewDocumentNote: IRequestReviewDocumentNote) => {
        this.submitting = true;
        try {
            await agent.RequestReviewDocumentNotes.create(requestReviewDocumentNote);
            runInAction('create RequestReviewDocumentNote', () => {
                this.submitting = false;
            });
            toast.success('Saved');
            this.rootStore.requestReviewDocumentStore.incrementRequestReviewDocumentNote(requestReviewDocumentNote.requestReviewDocumentId);
            this.rootStore.modalStore.closeModal();
        } catch (error) {
            runInAction('create RequestReviewDocumentNote error', () => {
                this.submitting = false;
            });
            toast.error('Problem submitting data');
        }
    };

    deleteRequestReviewDocumentNote = async (requestReviewDocumentNoteId: string) => {
        this.submitting = true;
        try {
            await agent.RequestReviewDocumentNotes.delete(requestReviewDocumentNoteId);


            runInAction('delete RequestReviewDocumentNote', () => {
                this.submitting = false;
                this.RequestReviewDocumentNoteRegistry.delete(requestReviewDocumentNoteId);
            });
            toast.success('Saved');

        } catch (error) {
            runInAction('delete RequestReviewDocumentNote error', () => {
                this.submitting = false;
            });
            toast.error('Problem submitting data');
        }
    };

    editRequestReviewDocumentNote = async (requestReviewDocumentNote: IRequestReviewDocumentNote) => {

    };



}
decorate(RequestReviewDocumentNoteStore, {
    RequestReviewDocumentNoteRegistry: observable,
    RequestReviewDocumentNote: observable,
    loadingInitialReviewDocumentNotes: observable,
    submitting: observable,
    target: observable,
    requestReviewDocumentNoteCount: observable,
    reviewDocumentNotePages: observable,
    predicate: observable,

    loadRequestReviewDocumentNote: action,
    loadRequestReviewDocumentNotes: action,
    ClearRequestReviewDocumentNote: action,
    setPredicate: action,
    setPageReviewDocumentNotes: action,
    createRequestReviewDocumentNote: action,
    editRequestReviewDocumentNote: action,

    requestReviewDocumentNotesById: computed,
    requestReviewDocumentNotesByDate: computed,
    axiosParams: computed,
    totalReviewDocumentNotePages: computed
});